<template>
  <div class="p-4 space-y-4" v-if="config.liveStreams">
    <div class="flex items-baseline pb-3 space-y-3 flex-col lg:flex-row lg:space-x-6 lg:space-y-0 border-b border-gray-300">
      <h3 class="flex-1 text-3xl uppercase font-extrabold">
        Live Streams – <span v-if="filteredStreams.length !== sortedStreams.length">{{ filteredStreams.length }} / </span>{{ sortedStreams.length }}
      </h3>
      <div class="flex space-x-4 text-gray-400 uppercase select-none">
        <span>
          Filter:
          <span class="cursor-pointer text-blue-500 hover:text-blue-800" @click="toggleConfigKey('streamsFilter', ['all', 'avatars', 'new avatars', 'favorites'])">
            {{ titles[config.streamsFilter] || config.streamsFilter }}
          </span>
        </span>
        <span>
          Sort by:
          <span class="cursor-pointer text-blue-500 hover:text-blue-800" @click="toggleConfigKey('streamsSort', ['channel.name', 'viewers', 'channel.followers', 'startedAt'])">
            {{ titles[config.streamsSort] || config.streamsSort }}
          </span>
        </span>
      </div>
    </div>

    <transition-group class="flex flex-wrap -ml-2" name="streams" tag="div" v-if="filteredStreams.length">
      <div class="streams-item mb-4 w-full flex-col space-y-1" :class="responsiveClass" v-for="stream in filteredStreams" :key="stream.id">
        <Stream :stream-id="+stream.id" v-if="config.livePreviews" />
        <div class="flex" :class="config.iconSize > 50 && !config.livePreviews ? `flex-col space-y-1` : 'items-center space-x-1'">
          <ChannelIcon :channel-id="+stream.id" :size="config.livePreviews ? 50 : config.iconSize" v-if="config.icons" />
          <ChannelInfo :channel-id="+stream.id" :style="{ width: infoWidth }" />
        </div>
      </div>
    </transition-group>

    <div class="text-xl" v-else>No live streams</div>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import Stream from '@/components/Stream'
  import ChannelIcon from '@/components/ChannelIcon'
  import ChannelInfo from '@/components/ChannelInfo'
  import { config, favorites, myAvatars, channelsById, streamsLoading, sortedStreams, toggleConfigKey } from '@/store'

  export default {
    name: 'Streams',
    components: {
      ChannelIcon,
      ChannelInfo,
      Stream,
    },
    setup() {
      const infoWidth = computed(() => (!config.livePreviews && config.iconSize > 50 ? `${config.iconSize}px` : '100%'))

      const responsiveClass = computed(() => {
        // fixed size
        if (config.iconSize > 50 && !config.livePreviews) {
          return `ml-2 w-${config.iconSize}px`
        }
        // float size
        if (config.leaderboard && config.livePreviews) {
          return 'pl-2 md:w-1/2 lg:w-1/3 xl:w-1/4 2xl:w-1/5'
        }
        if (config.leaderboard || config.livePreviews) {
          return 'pl-2 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 2xl:w-1/6'
        }
        return 'pl-2 xs:w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6 2xl:w-1/7'
      })

      const filteredStreams = computed(() => {
        switch (config.streamsFilter) {
          case 'avatars':
            return sortedStreams.value.filter(stream => channelsById.value[stream.id] && channelsById.value[stream.id].avatar)
          case 'new avatars':
            return sortedStreams.value.filter(stream => channelsById.value[stream.id] && channelsById.value[stream.id].avatar && !myAvatars.value.includes(stream.id))
          case 'favorites':
            return sortedStreams.value.filter(stream => favorites.value.includes(stream.id))
        }
        return sortedStreams.value
      })

      return {
        config,
        streamsLoading,
        sortedStreams,
        filteredStreams,
        responsiveClass,
        infoWidth,
        titles: {
          startedAt: 'start time',
          'channel.name': 'name',
          'channel.followers': 'followers',
        },
        toggleConfigKey,
      }
    },
  }
</script>

<style scoped>
  .streams-item {
    transition: all 0.2s;
  }
  .streams-move {
    transition: all 0.2s;
  }
  .streams-enter,
  .streams-leave-to {
    opacity: 0;
    transform: scale(0.5);
  }
  .streams-leave,
  .streams-enter-to {
    opacity: 1;
    transform: scale(1);
  }
</style>
